export { propValidator, PROP_TYPES } from '@fmpedia/validators'
